import { BASE_API_URL } from 'src/app/environment';
import { axiosInstance } from '../client';
import { GeneratedSocialPostResult } from '../types/social-types';

export async function shareSocialPost(
  post: GeneratedSocialPostResult,
  locationKey?: string | null,
): Promise<{ success: boolean }> {
  const url = `${BASE_API_URL}/ai/social/post`;
  const { data } = await axiosInstance.post(
    url,
    {
      campaignId: post.campaignId,
      locationKey: locationKey ?? undefined,
    },
    {
      headers: { 'Content-Type': 'application/json' },
    },
  );
  return data;
}
